<template>
  <div class="vx-row">
    <div class="vx-col md:w-4/4 w-full mb-base">
      <vx-card>
        <!-- Filter Merchant -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Merchant Name</span>
          </div>
          <!-- <div class="vx-col sm:w-2/5 w-full"> -->
          <div class="vx-col sm:w-2/5 w-full">
            <vue-simple-suggest
              pattern="\w+"
              v-model="model"
              :list="getList"
              :max-suggestions="1000"
              :min-length="0"
              :debounce="200"
              :filter-by-query="false"
              :prevent-submit="true"
              :controls="{
                selectionUp: [38, 33],
                selectionDown: [40, 34],
                select: [13, 36],
                hideList: [27, 35],
              }"
              :mode="mode"
              :nullable-select="true"
              ref="suggestComponent"
              placeholder="Search information..."
              value-attribute="id"
              display-attribute="text"
              @select="onSuggestSelect"
            >
              <div class="g">
                <input
                  id="merchant-search"
                  type="text"
                  placeholder="Select merchant"
                />
              </div>

              <template
                slot="misc-item-above"
                slot-scope="{ suggestions, query }"
              >
                <div class="misc-item">
                  <span>You're searching for '{{ query }}'.</span>
                </div>

                <template v-if="suggestions.length > 0">
                  <div class="misc-item">
                    <span
                      >{{ suggestions.length }} suggestions are shown...</span
                    >
                  </div>
                  <hr />
                </template>

                <div class="misc-item" v-else-if="!loading">
                  <span>No results</span>
                </div>
              </template>

              <div
                slot="suggestion-item"
                slot-scope="scope"
                :title="scope.suggestion.description"
              >
                <div class="text">
                  <span v-html="boldenSuggestion(scope)"></span>
                </div>
              </div>

              <div
                class="misc-item"
                slot="misc-item-below"
                slot-scope="{}"
                v-if="loading"
              >
                <span>Loading...</span>
              </div>
            </vue-simple-suggest>
          </div>
        </div>

        <!-- Filter Device -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Device Name</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <v-select
              id="cbo-merchant"
              inputId="txt-device"
              v-model="filter_device"
              placeholder="Select device"
              :options="device_list"
            >
            </v-select>
          </div>
        </div>

        <!-- Filter Date -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Device Date Activity </span>
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            <flat-pickr
              id="dtp-transaction-start-date"
              :config="configFromdateTimePicker"
              v-model="fromDate"
              placeholder="From Date"
              @on-change="onFromChange"
            />
            <div style="font-size: 12px">
              * Maximum 3 days
            </div>
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            <flat-pickr
              id="dtp-transaction-end-date"
              :config="configTodateTimePicker"
              v-model="toDate"
              placeholder="To Date"
              @on-change="onToChange"
            />
          </div>
        </div>

        <!-- Button -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>&nbsp;</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-button
              id="btn-filter"
              icon-pack="feather"
              icon="icon-search"
              v-on:click="fetchData(1, 20, true)"
              class="mr-3 mb-2 float-left"
              >Filter</vs-button
            >
            <vs-button
              id="btn-reset"
              icon-pack="feather"
              icon="icon-refresh-cw"
              color="warning"
              v-on:click="resetFilter()"
              class="mr-3 mb-2 float-left"
              >Reset</vs-button
            >
          </div>
        </div>
      </vx-card>
    </div>

    <vx-card>
      <!-- TABLE ACTION ROW -->
      <div class="flex flex-wrap justify-between items-center">
        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ currentPage * limit - (limit - 1) }} -
                {{
                  dataCount - currentPage * limit > 0
                    ? currentPage * limit
                    : dataCount
                }}
                of {{ dataCount }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu id="ddl-page-limit">
              <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                id="ddl-page-limit-3"
                @click="fetchData(1, 100)"
              >
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                id="ddl-page-limit-4"
                @click="fetchData(1, 150)"
              >
                <span>150</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                id="ddl-page-limit-5"
                @click="fetchData(1, totalData)"
              >
                <span>Show All</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="dataDevice"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="limit"
        :suppressPaginationPanel="true"
        :enableCellTextSelection="true"
      ></ag-grid-vue>
      <vs-pagination
        :total="totalPage"
        :max="maxPageNumbers"
        v-model="currentPage"
      />
    </vx-card>
  </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import 'flatpickr/dist/flatpickr.css';
import { url } from '@/configs/apiUrl';
import { AgGridVue } from 'ag-grid-vue';
import 'vue-simple-suggest/dist/styles.css';
import AxiosCall from '@/global/AxiosCall';
import flatPickr from 'vue-flatpickr-component';
import VueSimpleSuggest from 'vue-simple-suggest';
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss';

export default {
  components: {
    AgGridVue,
    flatPickr,
    'v-select': vSelect,
    VueSimpleSuggest,
  },
  data() {
    return {
      fromDate: null,
      toDate: null,
      configFromdateTimePicker: {
        minDate: null,
        maxDate: null,
        dateFormat: 'd-m-Y',
      },
      configTodateTimePicker: {
        minDate: null,
        dateFormat: 'd-m-Y',
      },
      dateType: 'Device Date',
      filter_device: '',
      device_list: [],
      merchant_list: [],
      filter_merchant: '',
      chosen: '',
      selected: null,
      urlx: null,
      model: null,
      mode: 'input',
      loading: false,
      searchQuery: '',
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
        filterParams: {
          applyButton: true,
          newRowsAction: 'keep',
        },
      },
      columnDefs: [
        {
          headerName: 'Device Code',
          field: 'devicecode',
          width: 300,
          filter: true,
          editable: false,
        },
        {
          headerName: 'Device Name',
          field: 'devicename',
          width: 300,
          filter: true,
          editable: false,
        },
        {
          headerName: 'Merchant Name',
          field: 'merchant_name',
          width: 300,
          filter: true,
          editable: false,
        },
        {
          headerName: 'Activities',
          field: 'activities',
          width: 300,
          filter: true,
          editable: false,
        },
        {
          headerName: 'Date',
          field: 'datetime',
          width: 300,
          filter: true,
          editable: false,
        },
      ],
      dataDevice: [],
      dataCount: 0,
      totalPage: 0,
      page: 1,
      limit: 20,
      totalData: 1,
      isFilter: false,
    };
  },
  watch: {
    '$store.state.windowWidth'(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned('Channel', null);
      } else this.gridOptions.columnApi.setColumnPinned('Channel', 'left');
    },
    selected: function(val) {
      let merchantidquery = '';
      this.filter_device = '';
      if (val !== null) {
        if (typeof val.merchant_id !== 'undefined') {
          merchantidquery = '?merchant_id=' + val.merchant_id;
        }
      }

      AxiosCall.Get(url.svd.device.combo + merchantidquery).then((resp) => {
        this.device_list = [];
        if (typeof resp.data !== 'undefined')
          for (let data of resp.data) {
            data.label =
              data.name + ' - ' + data.code + ' - ' + data.merchant_full_name;
            this.device_list.push(data);
          }
      });
    },

    filter_device: function(val) {
      if (val === null) {
        this.filter_device = '';
      }
    },

    filter_merchant: function(val) {
      if (val === null) {
        this.filter_merchant = '';
      }
    },
  },
  computed: {
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.fetchData(val, this.limit);
      },
    },
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: 'default',
      });
    },

    fetchData(page, limit, filter) {
      this.page = page;
      this.limit = limit;
      let newPage = page;
      if (this.dataCount != 0) {
        let totalPages = Math.ceil(this.dataCount / limit);
        if (page > totalPages) {
          newPage = this.totalPages;
        }
      }
      newPage;
      let newUrl = url.device_event.list + '?page=' + page + '&limit=' + limit;

      if (!filter && !this.isFilter) {
        this.openLoading();

        AxiosCall.Get(newUrl)
          .then((res) => {
            this.$vs.loading.close();
            this.dataDevice = [];
            this.dataCount = 0;
            this.totalPage = 0;
            if (res.data.data.length !== 0) {
              this.totalData = parseInt(res.data.total);
              let no = 1;
              for (let data of res.data.data) {
                data.no = (this.page - 1) * this.limit + no;
                this.dataDevice.push(data);
                no++;
              }

              this.dataCount = res.data.total;
              this.page = page;
              if (limit >= this.dataCount) {
                this.limit = this.dataDevice.length;
              } else {
                this.limit = limit;
              }

              this.gridApi.paginationSetPageSize(this.limit);
              this.totalPage = res.data.lastPage;
            } else {
              this.totalData = parseInt(res.data.total);
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            console.log(e);
          });
      } else {
        let fromDate = '';
        let toDate = '';

        this.isFilter = true;

        if (this.filter_merchant != null || this.filter_merchant != '') {
          newUrl += '&merchantcode=' + this.filter_merchant;
        }

        if (this.filter_device != null || this.filter_device != '') {
          if (
            this.filter_device.code != undefined &&
            this.filter_device.code != null
          ) {
            newUrl += '&devicecode=' + this.filter_device.code;
          }
        }

        if (this.fromDate == '' && this.toDate != '') {
          this.$vs.loading.close();
          swal.fire({
            type: 'warning',
            title: 'Alert',
            text: 'Start date must be filled!',
          });
          return false;
        }

        if (this.fromDate == null && this.toDate != null) {
          this.$vs.loading.close();
          swal.fire({
            type: 'warning',
            title: 'Alert',
            text: 'Start date must be filled!',
          });
          return false;
        }

        if (this.fromDate != null && this.toDate == null) {
          this.$vs.loading.close();
          swal.fire({
            type: 'warning',
            title: 'Alert',
            text: 'End date must be filled!',
          });
          return false;
        }

        if (this.fromDate != '' && this.toDate == '') {
          this.$vs.loading.close();
          swal.fire({
            type: 'warning',
            title: 'Alert',
            text: 'End date must be filled!',
          });
          return false;
        }

        fromDate = this.fromDate
          .split('-')
          .reverse()
          .join('-');
        toDate = this.toDate
          .split('-')
          .reverse()
          .join('-');

        let start_date = moment(fromDate);
        let end_date = moment(toDate);
        let range_date = end_date.diff(start_date, 'days');
        if (range_date > 2) {
          this.$vs.loading.close();
          swal.fire({
            type: 'warning',
            title: 'Alert',
            text: 'Maximum date range is 3 days!',
          });
          return false;
        }

        this.openLoading();

        newUrl += '&startdate=' + fromDate + '&enddate=' + toDate;

        AxiosCall.Get(newUrl)
          .then((res) => {
            this.$vs.loading.close();
            this.dataDevice = [];
            this.dataCount = 0;
            this.totalPage = 0;
            if (res.data.data.length !== 0) {
              this.totalData = parseInt(res.data.total);
              let no = 1;
              for (let data of res.data.data) {
                data.no = (this.page - 1) * this.limit + no;
                this.dataDevice.push(data);
                no++;
              }

              this.dataCount = res.data.total;
              this.page = page;
              if (limit >= this.dataCount) {
                this.limit = this.dataDevice.length;
              } else {
                this.limit = limit;
              }

              this.gridApi.paginationSetPageSize(this.limit);
              this.totalPage = res.data.lastPage;
            } else {
              this.totalData = parseInt(res.data.total);
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            console.log(e);
          });
      }
    },

    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr);
    },

    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
    },

    resetFilter() {
      document.getElementById('merchant-search').value = '';
      this.filter_device = '';
      this.filter_merchant = '';
      this.fromDate = null;
      this.toDate = null;
      this.page = 1;
      this.limit = 20;
      this.selected = null;
      this.model = null;
      this.isFilter = false;
      this.fetchData(1, 20);
    },

    getList() {
      let merchant = JSON.parse(localStorage.getItem('userInfo')).merchant;
      let merchantid =
        merchant.id !== undefined
          ? merchant.id
          : merchant.parent_id !== undefined
          ? merchant.parent_id
          : '';
      let url = this.urlx.svd.merchant.list_by_parent_id + '/' + merchantid;
      if (this.model !== null) url += '?search_merchant=' + this.model;

      return new Promise((resolve, reject) => {
        AxiosCall.Get(url)
          .then((response) => {
            if (response.code !== 200) {
              reject();
            }
            let result = [];
            let i = 1;
            for (let data of response.data) {
              data.merchant_id = data.id;
              data.id = i + 1;
              let depth = '- ';
              data.name = depth.repeat(data.depth) + data.full_name;
              data.text = depth.repeat(data.depth) + data.full_name;
              data.code = data.code;
              i++;
              result.push(data);
            }
            resolve(result);
          })
          .catch((e) => {
            this.loading = false;
            reject(e);
          });
      });
    },

    boldenSuggestion(scope) {
      if (!scope) return scope;
      if (scope.query == '') {
        this.selected = null;
      }
      const { suggestion, query } = scope;
      let result = this.$refs.suggestComponent.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [''];
      return result.replace(
        new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'),
        '$1<b>$2</b>$3'
      );
    },

    onSuggestSelect(suggest) {
      this.filter_merchant = suggest.merchant_id;
      this.selected = suggest;
    },
  },
  mounted() {
    this.urlx = url;

    let merchant = JSON.parse(localStorage.getItem('userInfo')).merchant;

    let merchantidquery = '';

    let merchantid =
      merchant.id !== undefined
        ? merchant.id
        : merchant.parent_id !== undefined
        ? merchant.parent_id
        : '';

    if (merchantid !== '') merchantidquery = '?merchant_id=' + merchantid;

    AxiosCall.Get(url.svd.device.combo + merchantidquery).then((resp) => {
      this.device_list = [];
      if (typeof resp.data !== 'undefined')
        for (let data of resp.data) {
          data.label =
            data.name + ' - ' + data.code + ' - ' + data.merchant_full_name;
          this.device_list.push(data);
        }
    });

    this.fromDate = moment()
      .subtract(2, 'days')
      .format('DD-MM-YYYY');
    this.toDate = moment().format('DD-MM-YYYY');

    if (this.status) {
      this.$vs.notify({
        title: 'Device Event',
        text: 'Device event success',
        color: 'success',
        position: 'top-right',
      });
    }
    this.gridApi = this.gridOptions.api;
    this.gridOptions.getRowStyle = function(params) {
      if (params.node.rowIndex % 2 === 0) {
        return { background: '#f9f9f9' };
      }
    };
  },
};
</script>

<style>
.vdp-datepicker input {
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #626262;
  width: 100%;
}

.flatpickr-input {
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #626262;
  width: 100%;
}

.vue-simple-suggest.designed .suggestions {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  top: calc(100% + 5px);
  border-radius: 3px;
  border: 1px solid #aaa;
  background-color: #fff;
  opacity: 1;
  z-index: 1000;
  overflow: scroll;
  height: 300px;
}
.cell-wrap-text {
  white-space: pre-wrap !important;
}
</style>
